<template>
  <div>
    <h2>此页面您没有权限访问!</h2>
  </div>
</template>

<style lang="scss" scoped>

div {
  width: 300px;
  margin: auto;
  padding-top: 200px;
}

</style>
